import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon, TrendingUpIcon } from 'lucide-react';
interface CompletedDeal {
  id: number;
  property: string;
  location: string;
  purchasePrice: string;
  currentValue: string;
  annualReturn: string;
  occupancy: string;
  year: string;
}
export function CompletedDeals() {
  const completedDeals: CompletedDeal[] = [{
    id: 1,
    property: '2BR/2BA Condo',
    location: 'Marina Golden Zone',
    purchasePrice: '$280,000',
    currentValue: '$365,000',
    annualReturn: '12.3%',
    occupancy: '48 weeks/year',
    year: '2023'
  }, {
    id: 2,
    property: '3BR Villa',
    location: 'Pedregal',
    purchasePrice: '$1,850,000',
    currentValue: '$2,650,000',
    annualReturn: '8.7%',
    occupancy: '42 weeks/year',
    year: '2022'
  }, {
    id: 3,
    property: 'Ocean View Lot',
    location: 'East Cape',
    purchasePrice: '$320,000',
    currentValue: '$595,000',
    annualReturn: '22.1%',
    occupancy: 'N/A (Land)',
    year: '2021'
  }, {
    id: 4,
    property: '1BR/1BA Condo',
    location: 'Medano Beach',
    purchasePrice: '$175,000',
    currentValue: '$235,000',
    annualReturn: '13.8%',
    occupancy: '50 weeks/year',
    year: '2023'
  }, {
    id: 5,
    property: 'Commercial Retail',
    location: 'Marina Plaza',
    purchasePrice: '$750,000',
    currentValue: '$920,000',
    annualReturn: '7.9%',
    occupancy: '100% (NNN Lease)',
    year: '2022'
  }, {
    id: 6,
    property: '4BR Estate',
    location: 'Corridor',
    purchasePrice: '$2,100,000',
    currentValue: '$3,200,000',
    annualReturn: '15.2%',
    occupancy: '38 weeks/year',
    year: '2021'
  }];
  return <section id="completed" className="py-24 bg-white" data-id="element-41">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-42">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-43">
          <div className="flex items-center justify-center mb-4" data-id="element-44">
            <CheckCircle2Icon className="text-gold mr-2" size={32} data-id="element-45" />
            <span className="text-gold text-sm font-semibold tracking-wider uppercase" data-id="element-46">
              Track Record
            </span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-navy mb-6" data-id="element-47">
            Completed Deals
          </h2>
          <p className="text-xl text-slate max-w-3xl mx-auto" data-id="element-48">
            Real results from deals sourced through Cabo Deal Flow. Performance
            verified.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-49">
          {completedDeals.map((deal, index) => <motion.div key={deal.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-gray-50 rounded-lg p-6 border border-gray-200 hover:border-gold transition-all" data-id="element-50">
              <div className="flex items-start justify-between mb-4" data-id="element-51">
                <div data-id="element-52">
                  <h3 className="text-lg font-serif font-semibold text-navy mb-1" data-id="element-53">
                    {deal.property}
                  </h3>
                  <p className="text-slate text-sm" data-id="element-54">{deal.location}</p>
                </div>
                <span className="bg-gold/20 text-gold px-2 py-1 rounded text-xs font-semibold" data-id="element-55">
                  {deal.year}
                </span>
              </div>

              <div className="space-y-3" data-id="element-56">
                <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-57">
                  <span className="text-slate text-sm" data-id="element-58">Purchase Price</span>
                  <span className="text-navy font-semibold font-mono text-sm" data-id="element-59">
                    {deal.purchasePrice}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-60">
                  <span className="text-slate text-sm" data-id="element-61">Current Value</span>
                  <span className="text-navy font-semibold font-mono text-sm" data-id="element-62">
                    {deal.currentValue}
                  </span>
                </div>
                <div className="flex justify-between items-center py-2 border-b border-gray-200" data-id="element-63">
                  <span className="text-slate text-sm" data-id="element-64">Annual Return</span>
                  <div className="flex items-center" data-id="element-65">
                    <TrendingUpIcon className="text-gold mr-1" size={14} data-id="element-66" />
                    <span className="text-gold font-bold font-mono text-sm" data-id="element-67">
                      {deal.annualReturn}
                    </span>
                  </div>
                </div>
                <div className="flex justify-between items-center py-2" data-id="element-68">
                  <span className="text-slate text-sm" data-id="element-69">Occupancy</span>
                  <span className="text-navy font-semibold text-sm" data-id="element-70">
                    {deal.occupancy}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}